<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_content") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="col-lg-12">
            <h3>{{ $t("PLACEHOLDERS.choose_type") }}</h3>

            <div class="type-selector">
              <label
                class="custom-radio"
                :class="{ selected: data.type === 'lecture' }"
              >
                <input type="radio" value="lecture" v-model="data.type" />
                <span class="radio-label">{{
                  $t("PLACEHOLDERS.lecture")
                }}</span>
              </label>

              <label
                class="custom-radio"
                :class="{ selected: data.type === 'exam' }"
              >
                <input type="radio" value="exam" v-model="data.type" />
                <span class="radio-label">{{ $t("PLACEHOLDERS.exam") }}</span>
              </label>
            </div>
          </div>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />
          <base-input
            col="6"
            type="text"
            v-if="data.type === 'lecture'"
            :placeholder="$t('PLACEHOLDERS.lecture_video')"
            v-model.trim="data.video"
            required
          />
          <base-select-input
            v-if="data.type === 'exam'"
            col="6"
            :placeholder="$t('PLACEHOLDERS.exam')"
            v-model.trim="data.exam"
            :optionsList="exams"
            required
          />
          <base-select-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.course')"
            v-model.trim="data.course"
            :optionsList="courses"
            required
          />
          <base-select-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.class_name')"
            v-model.trim="data.class"
            :optionsList="classes"
            required
          />

          <base-input
            col="6"
            v-if="data.type === 'lecture'"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionOnlyEn')"
            v-model.trim="data.description"
            required
          />
          <!-- End:: Name Input -->
          <div class="col-lg-6" v-if="data.type === 'lecture'">
            <h3 class="heading">{{ $t("PLACEHOLDERS.resources") }}</h3>
            <FileUpload
              :multiple="true"
              :preSelectedFile="data.uploadedFile"
              :accept="'application/pdf,image/*,video/*'"
              :urls="existingFiles"
              @onFileSelect="handleFileSelect"
              @onFileRemove="handleFileRemove"
            />
          </div>
          <div
            v-if="data.type === 'lecture'"
            class="input_wrapper switch_wrapper my-5 col-6"
          >
            <v-switch
              color="green"
              :label="
                data.can_read
                  ? $t('PLACEHOLDERS.enable_read')
                  : $t('PLACEHOLDERS.disabled_read')
              "
              v-model="data.can_read"
              hide-details
            ></v-switch>
          </div>

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import moment from "moment";
import FileUpload from "../../../components/formInputs/FileUpload.vue";

export default {
  name: "CreateBanks",
  components: { FileUpload },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      selectedFiles: [],
      existingFiles: [],
      file: null,
      exams: [],
      fileType: "",
      courses: [],
      classes: [],
      // Start:: Data Collection To Send
      data: {
        type: "lecture",
        name_ar: null,
        name_en: null,
        video: null,
        course: null,
        description: "",
        exam: null,
        class: null,
        can_read: true,
      

},
      // End:: Data Collection To Send
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },
  watch: {
    "data.course"(newVal) {
      this.data.class = null;
      if (newVal) this.getClasses(newVal);
    },
    "data.description"(newVal) {
      const onlyEnglish = newVal.replace(
        /[^a-zA-Z0-9 .,!?'"()\[\]{}\-_:;@#$/\\%^&*+=~`<>|\n\r]/g,
        ""
      );
      this.$nextTick(() => {
        this.data.description = onlyEnglish;
      });
    },
  },
  methods: {
    // filterEnglish(e) {
    //   const onlyEnglish = e.target.value.replace(
    //     /[^a-zA-Z0-9 .,!?'"()\[\]{}\-_:;@#$/\\%^&*+=~`<>|]/g,
    //     ""
    //   );
    //   console.log(onlyEnglish);
    //   this.data.description = onlyEnglish;
    // },
    handleFileSelect(files) {
      this.selectedFiles = files;
    },
    handleFileRemove(index) {
      this.existingFiles.splice(index, 1);
    },
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    handleFileSelected({ file, fileType }) {
      this.file = file;
      this.fileType = fileType;
    },
    handleFileRemoved() {
      this.file = null;
      this.fileType = "";
    },

    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("type", this.data.type);
      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      if (this.data.course) {
        REQUEST_DATA.append("course_id", this.data.course.id);
      }
      if (this.data.class) {
        REQUEST_DATA.append("class_name_id", this.data.class.id);
      }
      if (this.data.type === "lecture") {
        if (this.data.description) {
          REQUEST_DATA.append("description", this.data.description);
        }
        if (this.data.video) {
          REQUEST_DATA.append("video_url", this.data.video);
        }
        this.selectedFiles.forEach((file, i) => {
          console.log(file);
          REQUEST_DATA.append(`sources[${i}]`, file);
        });
        REQUEST_DATA.append("can_read", this.data.can_read ? 1 : 0);
      }
      if (this.data.type === "exam" && this.data.exam) {
        REQUEST_DATA.append("exam_id", this.data.exam.id);
      }
      try {
        await this.$axios({
          method: "POST",
          url: `course-contents`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/coursecontents/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    async getCourses() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "courses?page=0&limit=0&is_active=1",
        });
        this.courses = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getClasses(course) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `class-names?page=0&limit=0&is_active=1&course_id=${course.id}`,
        });
        this.classes = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getExams() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `exams?page=0&limit=0&is_active=1`,
        });
        this.exams = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },
  created() {
    this.getCourses();
    this.getExams();
  },
};
</script>

<style>
.type-selector {
  font-family: "Cairo", sans-serif;
  margin: auto;
  padding: 0px 8px;
  gap: 4px;
  display: flex;
}

.custom-radio {
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 2px solid #ccc;
  padding: 10px 15px;
  margin-bottom: 10px;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
  user-select: none;
}
.custom-radio.disabled {
  cursor: not-allowed !important;
  opacity: 0.6;
  pointer-events: none;
}

.custom-radio input[type="radio"] {
  display: none;
}
.custom-radio input[type="radio"]:disabled {
  cursor: not-allowed !important;
}

.custom-radio .radio-label {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.custom-radio.selected {
  border-color: #0b7477;
  background-color: #e6f8f8;
}

.custom-radio.selected .radio-label {
  color: #0b7477;
}

.selected-type {
  margin-top: 20px;
  font-size: 16px;
  color: #444;
}
</style>
